import { Button, Image, Modal } from "semantic-ui-react"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import CloseIcon from "../../../images/close-icon.svg"
import CarAdviseLogo from "../../../images/CarAdvise-Logo.svg"
import EbayLogo from "../../../images/ebay-logo.svg"
import UpDown from "../../../images/up-down.svg"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"

const EbayWelcomeModal = ({ user, t }) => {
  const [openModal, setCloseModel] = useState(true)

  useEffect(() => {
    if (openModal) {
      trackFirebaseAnalytics({
        event: gaJSON.ebay_booking_started
      })
    }
  }, [openModal])
  useEffect(() => {
    const hasSeen = localStorage.getItem("ebayWelcomeShown") === "true"
    if (!hasSeen) {
      setCloseModel(true)
      localStorage.setItem("ebayWelcomeShown", "true")
    } else {
      setCloseModel(false)
    }
  }, [])
  return (
    <Modal open={openModal} className={"ebay-welcome-modal"}>
      <Image
        src={CloseIcon}
        width="24px"
        height="24px"
        className="close-icon"
        onClick={() => {
          localStorage.setItem("ebayWelcomeShown", "true")
          setCloseModel(false)
        }}
      />
      <div className="ebay-welcome">
        <div className="top-log">
          <Image className="caradvise-logo" src={CarAdviseLogo} alt="CarAdvise Logo" />
          {/*  <Image className="caradvise-ebay-up-down" src={UpDown} alt="CarAdvise Logo" />
          <Image className="caradvise-ebay-logo" src={EbayLogo} alt="CarAdvise Logo" />*/}
        </div>
        <p className="hi-user">Hi, {user.firstName}</p>
        <p className="what-to-do">{t("letsGetYourTiresInstalled")}</p>
        <div className="ebay-notes">
          <FontAwesomeIcon className="info-Icon-retail-price" icon={faInfoCircle} />
          <p>{t("youWillNeeYourVehicleDetails")}</p>
        </div>
        <Button
          fluid
          loading={false}
          onClick={() => {
            localStorage.setItem("ebayWelcomeShown", "true")
            setCloseModel(false)
          }}
          disabled={false}
          className="primary-button"
        >
          {t("dashboard:bookAppointmentLabel")}
        </Button>
      </div>
    </Modal>
  )
}

function mapStateToProps(state) {
  const user = state.user || {}

  return {
    user
  }
}

export default connect(mapStateToProps)(
  withTranslation(["welcomeModal", "vehicleDetails"])(EbayWelcomeModal)
)
